var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tree-content"},[_c('el-tree',{ref:"catagoryTree",staticClass:"tree-comp",attrs:{"props":_vm.defaultProps,"filter-node-method":_vm.filterNodeTree,"load":_vm.loadNode,"accordion":"","highlight-current":"","node-key":"id","lazy":"","render-content":_vm.renderContent},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4740d78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/column/lefttree.vue
// module id = null
// module chunks = 